var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayMarketLabelFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 64,
    viewBox: "0 0 238 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 64,
    rx: 12,
    fill: "#090909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1328_12522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5903 16.2064C50.2193 16.6007 50 17.2125 50 18.0048V46.3133C50 47.1069 50.2193 47.7175 50.5903 48.1117L50.6847 48.2039L66.4809 32.3459V32.1591V31.9722L50.6847 16.113L50.5903 16.2064Z",
    fill: "url(#paint0_linear_1328_12522)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7453 37.6334L66.4807 32.3457V32.1588V31.9719L71.7466 26.6855L71.8651 26.7534L78.1038 30.3118C79.885 31.3281 79.885 32.9908 78.1038 34.0084L71.8651 37.5668L71.7453 37.6334Z",
    fill: "url(#paint1_linear_1328_12522)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1328_12522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8654 37.5655L66.4797 32.1588L50.5903 48.1114C51.1768 48.736 52.1471 48.8128 53.2398 48.1908L71.8654 37.5655Z",
    fill: "url(#paint2_linear_1328_12522)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.8654 26.7523L53.2398 16.1283C52.1471 15.5049 51.1768 15.583 50.5903 16.2077L66.4809 32.1603L71.8654 26.7523Z",
    fill: "url(#paint3_linear_1328_12522)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.504 33.7077C116.671 33.7077 114.363 35.861 114.363 38.8267C114.363 41.7743 116.671 43.9456 119.504 43.9456C122.337 43.9456 124.646 41.7743 124.646 38.8267C124.644 35.861 122.336 33.7077 119.504 33.7077ZM119.504 41.9308C117.951 41.9308 116.613 40.6514 116.613 38.8279C116.613 36.9852 117.953 35.725 119.504 35.725C121.056 35.725 122.394 36.9852 122.394 38.8279C122.394 40.6501 121.056 41.9308 119.504 41.9308ZM108.287 33.7077C105.455 33.7077 103.147 35.861 103.147 38.8267C103.147 41.7743 105.455 43.9456 108.287 43.9456C111.121 43.9456 113.429 41.7743 113.429 38.8267C113.429 35.861 111.121 33.7077 108.287 33.7077ZM108.287 41.9308C106.735 41.9308 105.397 40.6514 105.397 38.8279C105.397 36.9852 106.736 35.725 108.287 35.725C109.84 35.725 111.178 36.9852 111.178 38.8279C111.179 40.6501 109.84 41.9308 108.287 41.9308ZM94.9471 35.2796V37.451H100.147C99.9916 38.6726 99.5846 39.5645 98.9632 40.1843C98.2069 40.9402 97.0232 41.7743 94.9471 41.7743C91.7463 41.7743 89.244 39.195 89.244 35.9958C89.244 32.7966 91.7463 30.2173 94.9471 30.2173C96.674 30.2173 97.9348 30.8961 98.8657 31.7687L100.399 30.2365C99.0981 28.9956 97.3724 28.046 94.9471 28.046C90.5626 28.046 86.8765 31.6135 86.8765 35.9958C86.8765 40.3781 90.5626 43.9456 94.9471 43.9456C97.3134 43.9456 99.0993 43.1693 100.495 41.7153C101.93 40.2806 102.377 38.2634 102.377 36.6349C102.377 36.1318 102.339 35.666 102.26 35.2784L94.9471 35.2796ZM149.508 36.9659C149.082 35.8225 147.781 33.7077 145.123 33.7077C142.485 33.7077 140.292 35.7828 140.292 38.8267C140.292 41.6961 142.466 43.9456 145.375 43.9456C147.722 43.9456 149.08 42.5109 149.644 41.6768L147.898 40.5129C147.316 41.3663 146.52 41.9284 145.375 41.9284C144.231 41.9284 143.416 41.4048 142.892 40.3769L149.74 37.546L149.508 36.9659ZM142.523 38.6726C142.466 36.6939 144.056 35.6865 145.202 35.6865C146.094 35.6865 146.85 36.133 147.103 36.7721L142.523 38.6726ZM136.956 43.6363H139.206V28.59H136.956V43.6363ZM133.269 34.8524H133.192C132.687 34.2506 131.717 33.7077 130.496 33.7077C127.934 33.7077 125.587 35.9573 125.587 38.8471C125.587 41.7165 127.934 43.9468 130.496 43.9468C131.718 43.9468 132.687 43.404 133.192 42.7841H133.269V43.5208C133.269 45.479 132.221 46.5262 130.534 46.5262C129.157 46.5262 128.303 45.538 127.954 44.7039L125.994 45.5187C126.557 46.8752 128.05 48.5434 130.534 48.5434C133.173 48.5434 135.404 46.992 135.404 43.2102V34.0195H133.27L133.269 34.8524ZM130.69 41.9308C129.137 41.9308 127.838 40.6309 127.838 38.8471C127.838 37.0429 129.137 35.725 130.69 35.725C132.221 35.725 133.424 37.0429 133.424 38.8471C133.424 40.6309 132.221 41.9308 130.69 41.9308ZM160.05 28.59H154.665V43.6363H156.911V37.936H160.048C162.539 37.936 164.988 36.1342 164.988 33.2636C164.988 30.393 162.54 28.59 160.05 28.59ZM160.107 35.8417H156.911V30.6843H160.107C161.787 30.6843 162.741 32.0744 162.741 33.2636C162.741 34.4287 161.787 35.8417 160.107 35.8417ZM173.994 33.6813C172.367 33.6813 170.683 34.3974 169.986 35.985L171.98 36.8167C172.406 35.985 173.201 35.7129 174.033 35.7129C175.195 35.7129 176.376 36.4098 176.396 37.6483V37.8036C175.989 37.5713 175.117 37.2235 174.052 37.2235C171.903 37.2235 169.713 38.4042 169.713 40.6104C169.713 42.6241 171.476 43.9203 173.451 43.9203C174.961 43.9203 175.795 43.2427 176.317 42.4483H176.394V43.6098H178.564V37.8409C178.566 35.1713 176.569 33.6813 173.994 33.6813ZM173.722 41.9272C172.988 41.9272 171.96 41.5589 171.96 40.6489C171.96 39.4875 173.239 39.0421 174.344 39.0421C175.33 39.0421 175.796 39.2552 176.396 39.5452C176.221 40.9402 175.02 41.9272 173.722 41.9272ZM186.466 34.0098L183.891 40.5334H183.814L181.14 34.0098H178.72L182.729 43.1272L180.443 48.1992H182.786L188.965 34.0098H186.466ZM166.228 43.6363H168.474V28.59H166.228V43.6363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6666 19.6902C94.6666 20.6806 94.3683 21.4688 93.7703 22.0574C93.0917 22.757 92.2062 23.1068 91.1186 23.1068C90.0767 23.1068 89.19 22.7523 88.4621 22.0432C87.733 21.3329 87.3684 20.4537 87.3684 19.4042C87.3684 18.3536 87.733 17.4743 88.4621 16.7653C89.19 16.055 90.0767 15.7005 91.1186 15.7005C91.6359 15.7005 92.1304 15.7997 92.5997 15.9971C93.0701 16.1956 93.4467 16.4592 93.7282 16.7889L93.0941 17.4129C92.6165 16.8515 91.9584 16.5714 91.1174 16.5714C90.357 16.5714 89.7001 16.8338 89.1454 17.3585C88.5908 17.8832 88.3141 18.5651 88.3141 19.403C88.3141 20.2409 88.5908 20.9228 89.1454 21.4476C89.7001 21.9723 90.357 22.2346 91.1174 22.2346C91.9235 22.2346 92.596 21.9711 93.1339 21.4428C93.4828 21.0989 93.6849 20.6203 93.739 20.0069H91.1174V19.1549H94.6149C94.651 19.3404 94.6666 19.5189 94.6666 19.6902Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.213 16.7287H96.9263V18.9765H99.8908V19.8286H96.9263V22.0763H100.213V22.9485H95.9986V15.8577H100.213V16.7287Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.125 22.9485H103.197V16.7287H101.18V15.8577H106.141V16.7287H104.125V22.9485Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.73 22.9485V15.8577H110.658V22.9485H109.73Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.771 22.9485H113.844V16.7287H111.827V15.8577H116.788V16.7287H114.771V22.9485Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.178 22.0326C125.468 22.7488 124.586 23.1069 123.531 23.1069C122.476 23.1069 121.594 22.7488 120.885 22.0326C120.175 21.3164 119.822 20.4395 119.822 19.4031C119.822 18.3667 120.175 17.4898 120.885 16.7736C121.594 16.0574 122.476 15.6982 123.531 15.6982C124.58 15.6982 125.461 16.0586 126.173 16.7783C126.885 17.498 127.242 18.3726 127.242 19.4031C127.242 20.4395 126.887 21.3164 126.178 22.0326ZM121.57 21.4382C122.104 21.97 122.757 22.2347 123.531 22.2347C124.305 22.2347 124.959 21.9688 125.492 21.4382C126.026 20.9064 126.295 20.228 126.295 19.4031C126.295 18.5782 126.026 17.8998 125.492 17.368C124.959 16.8362 124.305 16.5715 123.531 16.5715C122.757 16.5715 122.104 16.8374 121.57 17.368C121.037 17.8998 120.769 18.5782 120.769 19.4031C120.769 20.228 121.037 20.9064 121.57 21.4382Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.543 22.9485V15.8577H129.672L133.18 21.3732H133.22L133.18 20.007V15.8577H134.108V22.9485H133.139L129.469 17.1648H129.429L129.469 18.5309V22.9485H128.543Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6666 19.6902C94.6666 20.6806 94.3683 21.4688 93.7703 22.0574C93.0917 22.757 92.2062 23.1068 91.1186 23.1068C90.0767 23.1068 89.19 22.7523 88.4621 22.0432C87.733 21.3329 87.3684 20.4537 87.3684 19.4042C87.3684 18.3536 87.733 17.4743 88.4621 16.7653C89.19 16.055 90.0767 15.7005 91.1186 15.7005C91.6359 15.7005 92.1304 15.7997 92.5997 15.9971C93.0701 16.1956 93.4467 16.4592 93.7282 16.7889L93.0941 17.4129C92.6165 16.8515 91.9584 16.5714 91.1174 16.5714C90.357 16.5714 89.7001 16.8338 89.1454 17.3585C88.5908 17.8832 88.3141 18.5651 88.3141 19.403C88.3141 20.2409 88.5908 20.9228 89.1454 21.4476C89.7001 21.9723 90.357 22.2346 91.1174 22.2346C91.9235 22.2346 92.596 21.9711 93.1339 21.4428C93.4828 21.0989 93.6849 20.6203 93.739 20.0069H91.1174V19.1549H94.6149C94.651 19.3404 94.6666 19.5189 94.6666 19.6902Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.213 16.7287H96.9263V18.9765H99.8908V19.8286H96.9263V22.0763H100.213V22.9485H95.9986V15.8577H100.213V16.7287Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.125 22.9485H103.197V16.7287H101.18V15.8577H106.141V16.7287H104.125V22.9485Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.73 22.9485V15.8577H110.658V22.9485H109.73Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.771 22.9485H113.844V16.7287H111.827V15.8577H116.788V16.7287H114.771V22.9485Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M126.178 22.0326C125.468 22.7488 124.586 23.1069 123.531 23.1069C122.476 23.1069 121.594 22.7488 120.885 22.0326C120.175 21.3164 119.822 20.4395 119.822 19.4031C119.822 18.3667 120.175 17.4898 120.885 16.7736C121.594 16.0574 122.476 15.6982 123.531 15.6982C124.58 15.6982 125.461 16.0586 126.173 16.7783C126.885 17.498 127.242 18.3726 127.242 19.4031C127.242 20.4395 126.887 21.3164 126.178 22.0326ZM121.57 21.4382C122.104 21.97 122.757 22.2347 123.531 22.2347C124.305 22.2347 124.959 21.9688 125.492 21.4382C126.026 20.9064 126.295 20.228 126.295 19.4031C126.295 18.5782 126.026 17.8998 125.492 17.368C124.959 16.8362 124.305 16.5715 123.531 16.5715C122.757 16.5715 122.104 16.8374 121.57 17.368C121.037 17.8998 120.769 18.5782 120.769 19.4031C120.769 20.228 121.037 20.9064 121.57 21.4382Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.543 22.9485V15.8577H129.672L133.18 21.3732H133.22L133.18 20.007V15.8577H134.108V22.9485H133.139L129.469 17.1648H129.429L129.469 18.5309V22.9485H128.543Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1328_12522",
    x: 50,
    y: 15.6981,
    width: 29.4397,
    height: 32.9223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1328_12522"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1328_12522",
    result: "effect2_innerShadow_1328_12522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1328_12522",
    x: 50.5903,
    y: 32.1588,
    width: 21.2751,
    height: 16.4617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1328_12522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1328_12522",
    x1: 65.0807,
    y1: 17.7053,
    x2: 43.5999,
    y2: 39.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1328_12522",
    x1: 80.4225,
    y1: 32.1588,
    x2: 49.5721,
    y2: 32.1588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1328_12522",
    x1: 68.9406,
    y1: 35.0949,
    x2: 39.8099,
    y2: 64.1123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1328_12522",
    x1: 46.5885,
    y1: 6.78404,
    x2: 59.5962,
    y2: 19.7411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMarketLabelFull);
export default __webpack_public_path__ + "static/media/PlayMarketLabelFull.5dc494a3f6cb18907969ad1e23404d23.svg";
export { ForwardRef as ReactComponent };